<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue';

interface ComponentProps {
    image: string;
    title?: string;
    imageAlt?: string;
    slideNumber?: number;
    totalSlides?: number;
    showSlideNumber?: boolean;
}

withDefaults(defineProps<ComponentProps>(), {
    title: '',
    imageAlt: '',
    showSlideNumber: true,
});

const svgObject = ref<HTMLObjectElement | null>(null);

function applyBrandColor() {
    const doc = svgObject.value?.contentDocument;
    if (!doc) return;

    const brandColor =
        getComputedStyle(document.documentElement)
            .getPropertyValue('--ch-primary')
            .trim() || '#156fbe';

    doc.documentElement.style.setProperty('color', brandColor);
}

onMounted(() => {
    nextTick(() => {
        if (svgObject.value?.contentDocument) applyBrandColor();
    });
});
</script>

<template>
    <div class="instruction">
        <div class="title-row">
            <h3>{{ title }}</h3>
            <app-chip
                v-if="showSlideNumber">
                {{ slideNumber }} of {{ totalSlides }}
            </app-chip>
        </div>
        <div class="instruction-content">
            <slot></slot>
        </div>
        <object
            ref="svgObject"
            :data="image"
            class="instruction-image"
            type="image/svg+xml"
            @load="applyBrandColor">
            <img
                :src="image"
                :alt="imageAlt" />
        </object>
    </div>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.instruction {
    padding: 1rem;
    background-color: $gray-lightest;
    border-radius: 4px;

    .title-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .title-row h3 {
        flex-grow: 1;
        color: $black-med;
        font-family: $family-sans-serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
    }

    .instruction-content {
        padding: .5rem 0;
    }

    .instruction-image {
        display: block;
    }
}

</style>